module.exports = __webpack_public_path__ + "static/media/saffola.4f85d0c7.jpg";